import {NEWS_FIND_ALL} from "../utils/Constant";

const news = function (state = {}, action) {
  switch (action.type) {
    case NEWS_FIND_ALL:
      return state;
    default :
      return state;
  }
}
export default news;
